import { Fragment } from 'react';
import { flexRender, Table } from '@tanstack/react-table';
import { SourcingFunnelDetails } from 'api-clients/monolith';
import { cn } from '@/utils/classnames';

interface SourcingOpeningsProps {
  table: Table<SourcingFunnelDetails>;
  gridTemplateColumns?: string;
}

export function SourcingOpenings({ table }: SourcingOpeningsProps) {
  return (
    <>
      {table.getRowModel().rows.map((row, index) => {
        const cells = row.getVisibleCells();
        const nameCell = cells.find(c => c.column.id === 'name');
        const metricCells = cells.filter(c => c.column.id !== 'name');

        return (
          <div
            key={row.id}
            className={cn(
              'bg-fx-neutral-100 flex items-center px-4',
              index === 0
                ? 'pb-3 pt-5'
                : 'border-fx-neutral-200 border-t py-3',
            )}
          >
            {/* Info column: opening name */}
            {nameCell && (
              <div className="flex w-[216px] shrink-0 items-center">
                {flexRender(
                  nameCell.column.columnDef.cell,
                  nameCell.getContext(),
                )}
              </div>
            )}

            {/* Metric columns with shorter dividers (no column labels) */}
            {metricCells.map(cell => (
              <Fragment key={cell.id}>
                <div className="bg-fx-neutral-200 h-10 w-px shrink-0" />
                <div className="flex min-w-[80px] flex-1 flex-col items-center gap-2">
                  {flexRender(cell.column.columnDef.cell, cell.getContext())}
                </div>
              </Fragment>
            ))}
          </div>
        );
      })}
    </>
  );
}
